import { Controller } from "@hotwired/stimulus";

// Increment/decrement buttons for .input-group--number
export default class extends Controller {
  static targets = ["input"];

  declare readonly inputTarget: HTMLInputElement;

  increment() {
    this.step(1);
  }

  decrement() {
    this.step(-1);
  }

  step(direction: number) {
    const input = this.inputTarget;
    const stepSize = input.step && input.step !== "any" ? parseFloat(input.step) : 1;
    const current = parseFloat(input.value) || 0;
    let next = current + direction * stepSize;

    if (input.min !== "") next = Math.max(next, parseFloat(input.min));
    if (input.max !== "") next = Math.min(next, parseFloat(input.max));

    input.value = String(next);
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
